import { ElementType, useEffect, useState } from 'react'
import Router from 'next/router'

import useFirebase from '../../hooks/useFirebase'
import Spinner from '../../components/Spinner'
import { isAuthenticating } from '../cache/cache'

export default function withAuthGuard(
  Component: ElementType,
  mustNotBeAuthenticated = false,
) {
  return props => {
    const { isInitializing, isAuthenticated } = useFirebase()
    const [didResolve, setDidResolve] = useState(!isInitializing)
    const [componentShouldRender, setComponentShouldRender] = useState(
      mustNotBeAuthenticated
        ? !isInitializing && !isAuthenticated
        : isAuthenticated,
    )

    useEffect(() => {
      const permission = mustNotBeAuthenticated
        ? !isAuthenticated
        : isAuthenticated

      if (!isAuthenticating() && didResolve && !isInitializing && !permission) {
        Router.replace('/')
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mustNotBeAuthenticated, isAuthenticated, didResolve, isInitializing])

    useEffect(() => {
      if (didResolve || isInitializing) return

      setDidResolve(true)
      const shouldRender = mustNotBeAuthenticated
        ? !isInitializing && !isAuthenticated
        : isAuthenticated

      setComponentShouldRender(shouldRender)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInitializing, isAuthenticated, componentShouldRender])

    return componentShouldRender ? (
      <Component {...props} />
    ) : (
      <Spinner color="black" />
    )
  }
}
